import { jsx as _jsx } from "react/jsx-runtime";
import { useScaleChecked } from '../../context/ScaleContext';
import { TREE_LEVEL_COLORS } from './TreeColors';
function LevelNode({ signal, startY, levelHeight }) {
    const { scaleX } = useScaleChecked();
    return (_jsx("line", { x1: scaleX()(signal.delta), y1: startY, x2: scaleX()(signal.delta), y2: startY + levelHeight, stroke: TREE_LEVEL_COLORS[0] }, `startLevelNode_${signal.id}`));
}
export default LevelNode;
